import { searchInitialState } from '@modules/feed/store/searchInitialState';
import { Dashboard } from 'v2/core/entities/dashboard';
import { SearchActionType } from './searchActionType';
import { SearchAction, SearchState } from './types';

export function searchReducer(
  state: SearchState,
  action: SearchAction,
): SearchState {
  switch (action.type) {
    case SearchActionType.SET_VISUAL: {
      return {
        ...state,
        visual: {
          ...state.visual,
          ...action.payload,
        },
      };
    }

    case SearchActionType.SET_QUERY: {
      return {
        ...state,
        query: state.query
          ? {
              ...state.query,
              ...action.payload,
            }
          : { ...searchInitialState.query, ...action.payload },
        visual: {
          ...state.visual,
          hasChangesToBeSaved: true,
        },
      };
    }

    case SearchActionType.SET_UPDATE_QUERY: {
      return {
        ...state,
        query: state.query
          ? {
              ...state.query,
              ...action.payload,
            }
          : { ...searchInitialState.query, ...action.payload },
        visual: {
          ...state.visual,
          hasChangesToBeSaved: false,
        },
      };
    }

    case SearchActionType.SET_DATA: {
      return {
        ...state,
        data: state.data
          ? {
              ...state.data,
              ...action.payload,
            }
          : (action.payload as Dashboard),
      };
    }

    case SearchActionType.SET_ARE_WIDGETS_LOADING: {
      return {
        ...state,
        visual: {
          ...state.visual,
          areWidgetsLoading: {
            ...state.visual.areWidgetsLoading,
            ...action.payload,
          },
        },
      };
    }

    case SearchActionType.RESET: {
      return searchInitialState;
    }

    default:
      return state;
  }
}
